import { render, staticRenderFns } from "./ElFeaturedPostText.vue?vue&type=template&id=9b662a12"
import script from "./ElFeaturedPostText.vue?vue&type=script&lang=js"
export * from "./ElFeaturedPostText.vue?vue&type=script&lang=js"
import style0 from "./ElFeaturedPostText.vue?vue&type=style&index=0&id=9b662a12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports